import { render } from "./Info.vue?vue&type=template&id=676660ae"
import script from "./Info.vue?vue&type=script&setup=true&lang=js"
export * from "./Info.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/Users/herianto/Projects/yeu-logistik/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/ItemAssets/Info.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "676660ae"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('676660ae', __exports__)) {
    console.log('reload')
    api.reload('676660ae', __exports__)
  }
  
  module.hot.accept("./Info.vue?vue&type=template&id=676660ae", () => {
    console.log('re-render')
    api.rerender('676660ae', render)
  })

}


export default __exports__